import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Repo.scss";
interface RepoProps {
  title: string;
  isInitializedAsOpen: boolean;
  iconColor: string;
  files: Array<any>;
  openFile: (e: any) => void;
}
const listVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0 },
};

const Repo: React.FC<RepoProps> = ({
  isInitializedAsOpen,
  title,
  iconColor,
  files,
  openFile,
}) => {
  const [open, setOpen] = useState(isInitializedAsOpen);
  return (
    <div className="repo-box">
      <div className="repo-box__title" onClick={() => setOpen(!open)}>
        {open ? (
          <svg
            style={{ margin: "0 13px 0 12px" }}
            width="13"
            height="9"
            viewBox="0 0 13 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.364 5.27715L11.314 0.327148L12.728 1.74115L6.364 8.10515L0 1.74115L1.414 0.327148L6.364 5.27715Z"
              fill="#607B96"
            />
          </svg>
        ) : (
          <svg
            style={{ margin: "0 13px 0 16px" }}
            width="9"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.69658 7.18971L0.746582 2.23971L2.16058 0.82571L8.52458 7.18971L2.16058 13.5537L0.746582 12.1397L5.69658 7.18971Z"
              fill="#607B96"
            />
          </svg>
        )}
        <svg
          style={{ margin: "0 8px 0 0" }}
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0802 4.30056V12.9672C15.0802 13.1588 15.0041 13.3425 14.8687 13.4779C14.7332 13.6134 14.5495 13.6895 14.358 13.6895H1.35796C1.16642 13.6895 0.982719 13.6134 0.847276 13.4779C0.711833 13.3425 0.635742 13.1588 0.635742 12.9672V3.57834H14.358C14.5495 3.57834 14.7332 3.65443 14.8687 3.78988C15.0041 3.92532 15.0802 4.10902 15.0802 4.30056ZM8.15696 2.1339H0.635742V1.41168C0.635742 1.22013 0.711833 1.03643 0.847276 0.900987C0.982719 0.765544 1.16642 0.689453 1.35796 0.689453H6.71252L8.15696 2.1339Z"
            fill={iconColor}
          />
        </svg>
        {title}
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            className="repo-box__content"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={listVariants}
            style={{ overflow: 'hidden' }}
          >
            {files.map((file) => (
              <motion.div
                key={file.id}
                variants={itemVariants}
                className="repo-box__content__file"
                onClick={() => openFile(file)}
                whileHover={{ x: 5 }}
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.44684 0.832031H16.0466C16.2617 0.832031 16.468 0.917486 16.6201 1.0696C16.7722 1.22171 16.8577 1.42801 16.8577 1.64313V14.6207C16.8577 14.8358 16.7722 15.0421 16.6201 15.1942C16.468 15.3463 16.2617 15.4318 16.0466 15.4318H1.44684C1.23172 15.4318 1.02542 15.3463 0.873307 15.1942C0.721197 15.0421 0.635742 14.8358 0.635742 14.6207V1.64313C0.635742 1.42801 0.721197 1.22171 0.873307 1.0696C1.02542 0.917486 1.23172 0.832031 1.44684 0.832031V0.832031ZM4.69122 10.9707V7.72635L6.31342 9.34854L7.93561 7.72635V10.9707H9.5578V5.29306H7.93561L6.31342 6.91525L4.69122 5.29306H3.06903V10.9707H4.69122ZM13.6133 8.53745V5.29306H11.9911V8.53745H10.3689L12.8022 10.9707L15.2355 8.53745H13.6133Z"
                    fill="#81A1C1"
                  />
                </svg>
                <span>{file.name}</span>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
export default Repo;
